const KEY = 'elts.guestKey';

/** A random id that ties a visitor's taster answers together. Kept in this browser only. */
export function guestKey(): string {
  try {
    const found = localStorage.getItem(KEY);
    if (found) return found;
    const fresh = crypto.randomUUID();
    localStorage.setItem(KEY, fresh);
    return fresh;
  } catch {
    return crypto.randomUUID();
  }
}

export function readGuestKey(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function forgetGuestKey(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // Nothing to do: the next sign-in simply tries again.
  }
}
